module.exports = __webpack_public_path__ + "media/CIS.153de4b9.mp3";